import type { RdCoverageStatus, RdListItem } from "../components/v2/rd-list-row";

// The legacy RD table's search and coverage filter (components/v2/rd-list.tsx),
// held apart from the table so it loads under `tsx --test` (NO-792 split it
// out unchanged).

export const ALL_COVERAGE = "all";

export type CoverageFilter = typeof ALL_COVERAGE | RdCoverageStatus;

// Local port of legacy lib/v2/rd-name.ts normalizeRdName (search matching).
export function normalizeRdName(name: string): string {
  return name.trim().replace(/\s+/g, " ").toLowerCase();
}

/** The RDs in the chosen coverage whose name or supervisor holds the query. */
export function filterRdList(
  rds: RdListItem[],
  query: string,
  coverageFilter: CoverageFilter
): RdListItem[] {
  const normalizedQuery = normalizeRdName(query);

  return rds.filter((rd) => {
    if (coverageFilter !== ALL_COVERAGE && rd.coverage.status !== coverageFilter) {
      return false;
    }

    if (!normalizedQuery) return true;

    const searchableText = normalizeRdName(
      [rd.name, rd.supervisorName ?? ""].join(" ")
    );

    return searchableText.includes(normalizedQuery);
  });
}
